import React, { useEffect } from "react";
import { QuestionProps } from "../../survey";
import QuestionLabel from "../components/question_label";
import { Answer } from "./generic";
import styled from "styled-components";
import TextArea from "../../../components/data_entry/text_area";
import InputQuestionWrapper from "../../../components/base_ui/higher_order_components/questions/input_question_wrapper";

const StyledDeprecatedInput = styled.div`
  margin-top: 2em;
`;

const StyledInput = styled.div`
  margin-top: ${({ theme }) => theme.sizing.scale600};
`;

export interface InputCustomization {
  qid: string;
  text: string;
  description?: string;
  optional?: boolean;
  qInfo: {
    type: string;
    placeholder?: string;
  };
}

export default function Input({
  customizations,
  currentAnswer,
  updateAnswer,
  setAbleToSubmit,
  showValidation,
  showRefreshedComponents = true,
}: QuestionProps<Answer, InputCustomization>) {
  const label = customizations.text;
  const description = customizations.description ?? "";

  const qid = customizations.qid;
  const optional = typeof customizations.optional === "undefined" ? false : customizations.optional;
  const answerIsValid =
    optional ||
    (currentAnswer && currentAnswer[qid] ? (currentAnswer[qid].length || 0) > 0 : false);

  // Adding setAbleToSubmit as dependency might break survey behavior
  // If you're making edits to this please check that this works with follow-up questions if applicable
  useEffect(() => {
    setAbleToSubmit(answerIsValid);
    // eslint-disable-next-line
  }, [answerIsValid, currentAnswer]);

  const deprecatedInput = (
    <StyledDeprecatedInput>
      <QuestionLabel
        label={label}
        htmlFor={`${qid}-follow-up`}
        questionIsOptional={optional}
        description={description}
      />
      <TextArea
        id={`${qid}-follow-up`}
        data-test="open-response-input"
        placeholder={customizations.qInfo.placeholder}
        rows={1}
        questionIsOptional={optional}
        onChange={({ currentTarget: { value: updatedResponse } }) =>
          updateAnswer({ [qid]: updatedResponse })
        }
        value={currentAnswer ? currentAnswer[qid] : ""}
      />
    </StyledDeprecatedInput>
  );

  const input = (
    <StyledInput>
      <InputQuestionWrapper
        id={`${qid}-follow-up`}
        dataTest="generic-input"
        label={label}
        secondaryText={description}
        placeholder={customizations.qInfo.placeholder}
        optional={optional}
        value={currentAnswer ? currentAnswer[qid] : ""}
        onChange={({ currentTarget: { value: updatedResponse } }) =>
          updateAnswer({ [qid]: updatedResponse })
        }
        errorMessage={
          showValidation && !answerIsValid ? "Please complete the required field." : undefined
        }
      />
    </StyledInput>
  );
  return showRefreshedComponents ? input : deprecatedInput;
}
